import {
  EditOutlined,
  UnorderedListOutlined,
  WechatOutlined,
} from '@ant-design/icons';
import { Tabs } from 'antd';

import { PREFIX } from '@app/constants';

import type { TabsProps } from 'antd';

import '@app/components/ChatMobileMenu/styles/ChatMobileMenu.desktop.scss';
import '@app/components/ChatMobileMenu/styles/ChatMobileMenu.mobile.scss';

const CHAT = 'chat';
type ContentType = 'list' | 'chat' | 'actions';
type ChatMobileMenuProps = {
  isMobileWidth: boolean;
  defaultActiveKey?: ContentType;
  setIsChatVisible: (isChatVisible: boolean) => void;
  setAreActionsVisible: (areActionsVisible: boolean) => void;
  setIsChatListVisible: (isChatListVisible: boolean) => void;
};

export const ChatMobileMenu = ({
  isMobileWidth,
  defaultActiveKey = CHAT,
  setIsChatVisible,
  setAreActionsVisible,
  setIsChatListVisible,
}: ChatMobileMenuProps) => {
  const manageMenuContentVisibility = (contentType: ContentType): void => {
    if (contentType === 'list') {
      setIsChatVisible(false);
      setAreActionsVisible(false);
      return setIsChatListVisible(true);
    }

    if (contentType === 'actions') {
      setIsChatListVisible(false);
      setIsChatVisible(false);
      return setAreActionsVisible(true);
    }

    setIsChatListVisible(false);
    setAreActionsVisible(false);
    setIsChatVisible(true);
  };

  const items: TabsProps['items'] = [
    {
      key: 'list',
      label: (
        <div onClick={() => manageMenuContentVisibility('list')}>
          <UnorderedListOutlined />
        </div>
      ),
      children: <></>,
    },
    {
      key: 'chat',
      label: (
        <div onClick={() => manageMenuContentVisibility('chat')}>
          <WechatOutlined />
        </div>
      ),
      children: <></>,
    },
    {
      key: 'actions',
      label: (
        <div onClick={() => manageMenuContentVisibility('actions')}>
          <EditOutlined />
        </div>
      ),
      children: <></>,
    },
  ];

  return (
    <div className={`${PREFIX}-chat-mobile-menu`}>
      {isMobileWidth && (
        <Tabs
          className="chat-content-tabs"
          tabPosition="bottom"
          type="card"
          defaultActiveKey={defaultActiveKey}
          items={items}
        />
      )}
    </div>
  );
};
